"use client";

import { activeSiteCountry } from "@config/site/site-config";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { formatDateOfBirth } from "@lib/utils/dateOfBirth";
import { dateRegex } from "@lib/validators/regex/general";
import { Text } from "@ecco/ui/text";
import { Box } from "@ecco/ui/box";
import { getPrivacyAttributes } from "@lib/monitoring/privacyAttributes";
import type { FC } from "react";

interface IProfileOverviewProps {
    fields: Record<string, string>;
}

export const ProfileOverview: FC<IProfileOverviewProps> = ({ fields }) => {
    const { get: getMicrocopy } = useMicrocopy();
    const country = activeSiteCountry;

    const values = Object.entries(fields)?.map?.(([key, value]) => {
        if (!key || !value) {
            return null;
        }

        const formattedValue = value.match(dateRegex)?.[0]
            ? formatDateOfBirth(value, country)
            : value;

        return (
            <Box key={key} mb={4}>
                <Text fontSize={["mobileBodyB2", "desktopBodyB2"]} fontWeight="bold" color="black">
                    {key}
                </Text>
                <Text
                    {...getPrivacyAttributes()}
                    fontSize={["mobileBodyB2", "desktopBodyB2"]}
                    fontWeight="bold"
                    color="black"
                >
                    {formattedValue}
                </Text>
            </Box>
        );
    });

    return (
        <Box p={[4, 4, 6]} bg="white">
            <Text
                fontWeight="bold"
                fontSize={["mobileBodyTextLarge", "mobileBodyTextLarge", "desktopBodyTextLarge"]}
                mb={4}
            >
                {getMicrocopy(CommonCMS.page, CommonCMS.profile.overview)}
            </Text>
            {values}
        </Box>
    );
};

export default ProfileOverview;
